export default "__VITE_ASSET__DjcOt_8U__"